import { CreateForm } from './createForm';

export const CreatePost = () => {
    return(
        <div className="min-h-[750px] bg-slate-200 px-10 py-5 text-center space-x-4">
            <CreateForm />
        </div>
    )
};